import { z } from "zod"

export const GROUPINGS = ["availability", "manufacturer"] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const groupChoiceSchema = z.enum([...GROUPINGS, "none"])

export const GROUPING_LABELS: Record<Grouping, string> = {
  availability: "Availability",
  manufacturer: "Manufacturer",
}
